import type { AxiosInstance } from 'axios';
import { IdVerificationModel } from '@/models/id-verifications';
import { IdVerification } from '../types/id-verifications';

class IdVerificationsService {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getVerification(reservationId: string): Promise<IdVerificationModel | undefined> {
    const response = await this.client.get<IdVerification[]>('/id-verifications', {
      params: {
        $query: {
          reservationId,
        }
      }
    });

    return response.data.data[0];
  }

  async approveVerification(verificationId: string) : Promise<IdVerificationModel> {
    const response = await this.client.patch<IdVerificationModel>(`/id-verifications/${verificationId}`, {
      state: 'approved'
    });

    return response.data;
  }
}

export { IdVerificationsService };
